import styled from 'styled-components';

export const SettlementContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-height: 0;
`;

export const SettlementHint = styled.span`
  font-size: 12px;
  color: #718096;
`;

// A rolagem fica aqui dentro, como na linha do tempo: o modal tem altura fixa.
export const InstallmentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 4px 8px 4px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const InstallmentRow = styled.div`
  display: grid;
  grid-template-columns: 40px 70px 1fr 150px 1fr 1fr 110px 150px 160px;
  align-items: center;
  gap: 12px;
  /* Folga embaixo para o aviso de minimo, que flutua sob o campo. */
  padding: 8px 12px 16px 12px;
  border-radius: 8px;
  border: 1px solid ${(props) => (props.$selected ? '#2670D1' : '#E2E8F0')};
  background: ${(props) => (props.$selected ? '#2670D108' : '#fff')};
`;

export const InstallmentHeader = styled(InstallmentRow)`
  border-color: transparent;
  background: transparent;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #718096;
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 14px;
  color: #2d3748;
  /* Ancora o aviso flutuante: ele aparece sob o campo sem empurra-lo. */
  position: ${(props) => (props.$anchor ? 'relative' : 'static')};
`;

export const CellNote = styled.span`
  font-size: 11px;
  color: ${(props) => (props.$warning ? '#FF3B30' : '#718096')};
  ${(props) =>
    props.$floating
      ? `
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 1px;
    white-space: nowrap;
  `
      : ''}
`;

// "Aplicar a todas", sob o campo de data. Flutua como o aviso de minimo, para
// nao desalinhar a linha.
export const CellLink = styled.button`
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 1px;
  padding: 0;
  border: none;
  background: none;
  font-size: 11px;
  color: #2670d1;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const ListFallback = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px 0;
`;

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  padding-top: 8px;
  border-top: 1px solid #e2e8f0;
`;

export const ActionTotal = styled.span`
  font-size: 14px;
  color: #4a5568;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

// O aviso e o motivo de a acao pedir confirmacao: a baixa nao tem volta pela
// tela.
export const WarningBox = styled.div`
  background: #ff950012;
  border-left: 4px solid #ff9500;
  border-radius: 6px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-shrink: 0;
`;

export const WarningTitle = styled.strong`
  font-size: 14px;
  color: #2d3748;
`;

export const WarningText = styled.span`
  font-size: 13px;
  color: #4a5568;
  line-height: 1.45;
`;

// Seletor Em aberto | Baixados, no topo da aba, quando o usuario pode baixar e
// estornar.
export const ModeBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;
